import { render, staticRenderFns } from "./downbtn.vue?vue&type=template&id=2c30d23a&scoped=true"
import script from "./downbtn.vue?vue&type=script&lang=js"
export * from "./downbtn.vue?vue&type=script&lang=js"
import style0 from "./downbtn.vue?vue&type=style&index=0&id=2c30d23a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c30d23a",
  null
  
)

export default component.exports